export default {
  header: 'Vi skal bekræfte dit telefonnummer',
  remember_device: {
    label: 'Husk denne enhed i {{days}} dage',
  },
  buttons: {
    confirm: 'Bekræft',
  },
  toasts: {
    invalid_code: 'Ugyldig kode. Prøv igen.',
  },
};
